(function($, window, undefined){ 'use strict'
	$.fn.cleave = function(options) {
		return this.each(function(){
			var cleave = new Cleave(this, options), $this = $(this);
			$this.data('cleave',cleave)
		});
	}
})(jQuery, window);